// A task as a tinted pill: the chain's colour, the task's code (and name), a
// learner dot, and a clock for steps that only run in the morning or the
// afternoon (a cure gate). Neutral otherwise: colour belongs to results.
import type { Half } from "../lib/types";
import { chainOf } from "../lib/chain";
import { Glyph } from "./Glyph";

export interface TaskChipProps {
  task: string | null;
  name?: string | null;
  group?: string | null;
  learner?: boolean;
  halfOnly?: Half | null;
  size?: "sm" | "lg";
  /** The Board's night surface. */
  night?: boolean;
  /** Show the name beside the code. */
  showName?: boolean;
}

export function TaskChip({ task, name, group, learner, halfOnly, size = "sm", night, showName = true }: TaskChipProps) {
  const chain = chainOf(task, group);
  const cls = ["chip", `chip--${chain}`, size === "lg" ? "chip--lg" : "", night ? "chip--night" : ""].filter(Boolean).join(" ");
  const gate = halfOnly ? (halfOnly === "AM" ? "Morning only" : "Afternoon only") : null;
  const label = [task ?? "Float", name, learner ? "learner" : null, gate].filter(Boolean).join(", ");
  return (
    <span className={cls} title={label} aria-label={label} data-chain={chain}>
      <span className="chip__code">{task ?? "Float"}</span>
      {showName && name ? <span className="chip__name">{name}</span> : null}
      {gate ? <span className="chip__clock" data-testid="chip-clock"><Glyph name="clock" size={night ? 18 : 12} /></span> : null}
      {learner ? <span className="chip__learner" data-testid="chip-learner" /> : null}
    </span>
  );
}
